(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojuri-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mojuri-announcement]').forEach((bar) => {
    if (bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    const items = Array.from(bar.querySelectorAll('[data-announcement-item]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (items.length < 2 || reduceMotion) return;

    let activeIndex = 0;
    const interval = Number(bar.dataset.interval) || 4500;

    window.setInterval(() => {
      items[activeIndex].classList.remove('is-active');
      items[activeIndex].setAttribute('aria-hidden', 'true');
      activeIndex = (activeIndex + 1) % items.length;
      items[activeIndex].classList.add('is-active');
      items[activeIndex].setAttribute('aria-hidden', 'false');
    }, interval);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojuri-clubs"] && !Shopify.designMode) return;
  try {
    

function initMojuriVision(scope){scope.querySelectorAll('[data-mv]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const form=root.querySelector('form'),steps=[...root.querySelectorAll('[data-step]')];if(!form||!steps.length)return;const next=root.querySelector('[data-next]'),back=root.querySelector('[data-back]'),submit=root.querySelector('[data-submit]'),progress=root.querySelector('.mv-progress');let current=0;form.noValidate=true;progress.hidden=false;const quantities=[...root.querySelectorAll('[data-quantity]')];function update(){const checked=[...root.querySelectorAll('[data-product]:checked')].map(x=>x.dataset.product);quantities.forEach(q=>{const active=checked.includes(q.dataset.quantity);q.hidden=!active;q.querySelector('input').disabled=!active});root.querySelector('[data-phone]').required=!!root.querySelector('[data-contact="phone"]:checked');const list=root.querySelector('[data-review]');list.replaceChildren();[...form.querySelectorAll('input[type="checkbox"]:checked'),...quantities.filter(q=>!q.hidden).map(q=>q.querySelector('input')),root.querySelector('[data-contact]:checked')].filter(Boolean).forEach(input=>{if(!input.value)return;const li=document.createElement('li');li.textContent=input.type==='number'?input.name.slice(8,-1)+': '+input.value:input.value;list.append(li)})}function show(i,focus){current=i;steps.forEach((s,j)=>s.hidden=j!==i);[...progress.children].forEach((s,j)=>{if(j===i)s.setAttribute('aria-current','step');else s.removeAttribute('aria-current')});back.hidden=i===0;next.hidden=i===steps.length-1;submit.hidden=i!==steps.length-1;root.querySelector('.mv-review').hidden=i!==steps.length-1;update();if(focus)steps[i].querySelector('legend').focus()}function valid(s){const invalid=[...s.querySelectorAll('input,textarea,select')].find(x=>!x.disabled&&!x.checkValidity());if(invalid){invalid.reportValidity();return false}return true}next.addEventListener('click',()=>{if(valid(steps[current]))show(current+1,true)});back.addEventListener('click',()=>show(current-1,true));form.addEventListener('change',update);form.addEventListener('input',update);form.addEventListener('submit',e=>{if(current<steps.length-1){e.preventDefault();if(valid(steps[current]))show(current+1,true);return}for(let i=0;i<steps.length;i++){const bad=[...steps[i].querySelectorAll('input,textarea,select')].some(x=>!x.disabled&&!x.checkValidity());if(bad){e.preventDefault();show(i,true);valid(steps[i]);return}}});show(0,false)})}initMojuriVision(document);document.addEventListener('shopify:section:load',e=>initMojuriVision(e.target));


  } catch(e) { console.error(e); }
})();
})();
